import request from '@/utils/request'

export default {
    getSiteInfo: function (data) {
        return request({
            url: '/tz/getSiteInfo',
            method: 'get',
            params: data
        })
    },
    // 水质监测
    getSZJCLocations: function () {
        return request({
            url: '/tz/getSZJCLocations',
            method: 'get',
        })
    },
    getSZJCSingleLocation: function (params) {
        return request({
            url: '/tz/getSZJCSingleLocation',
            method: 'get',
            params: params
        })
    },
    getSZJCSingleLocationWarning: function () {
        return request({
            url: '/tz/getSZJCSingleLocationWarning',
            method: 'get',
        })
    },
    getSZJCDetails: function (data) {
        return request({
            url: '/tz/getSZJCDetails',
            method: 'get',
            // edit lk 2020.6.15 start
            params: data
            // edit lk 2020.6.15 end
        })
    },
    // 施工安全管理-三维激光扫描
    // 查
    query3DLaserList: function (data) {
        return request({
            url: '/tz/query3DLaserList',
            method: 'post',
            data: data
        })
    },
    // 增, 改
    confirm3DLaser: function (data) {
        return request({
            url: '/tz/confirm3DLaser',
            method: 'post',
            data: data
        })
    },
    // 删
    delete3DLaser: function (data) {
        return request({
            url: '/tz/delete3DLaser',
            method: 'post',
            data: data
        })
    },
    // 人员培训/安委会会议
    queryTrainList: function (data) {
        return request({
            url: '/tz/queryTrainList',
            method: 'post',
            data: data
        })
    },
    handleLike: function (data) {
        return request({
            url: '/tz/handleLike',
            method: 'post',
            data: data
        })
    },
    handleComment: function (data) {
        return request({
            url: '/tz/handleComment',
            method: 'post',
            data: data
        })
    },
    // 隐患列表
    getSBYH: function (data) {
        return request({
            url: '/tz/getSBYH',
            method: 'post',
            data: data
        })
    },
    getCatalog: function (data) {
        return request({
            url: '/tz/getCatalog',
            method: 'get',
        })
    },
    // 隐患详情
    getSBYHTags: function (data) {
        return request({
            url: '/tz/getSBYHTags',
            method: 'post',
            data: data
        })
    },
    getReceiversOptions: function () {
        return request({
            url: '/tz/getReceiversOptions',
            method: 'post',
        })
    },
    getSBYHDetail: function (YHId) {
        return request({
            url: '/tz/getSBYHDetail',
            method: 'get',
            params: {
                YHId: YHId
            }
        })
    },
    handleSBYHWatch: function (data) {
        return request({
            url: '/tz/handleSBYHWatch',
            method: 'post',
            data: data
        })
    },
    handleSBYHForward: function (data) {
        return request({
            url: '/tz/handleSBYHForward',
            method: 'post',
            data: data
        })
    },
    handleSBYHComment: function (data) {
        return request({
            url: '/tz/handleSBYHComment',
            method: 'post',
            data: data
        })
    },
    handleSBYHTag: function (data) {
        return request({
            url: '/tz/handleSBYHTag',
            method: 'post',
            data: data
        })
    },
    handleAddSBYHTag: function (data) {
        return request({
            url: '/tz/handleAddSBYHTag',
            method: 'post',
            data: data
        })
    },
    handleSBYHDelete: function (data) {
        return request({
            url: '/tz/handleSBYHDelete',
            method: 'post',
            data: data
        })
    },
    handleSBYHModify: function (data) {
        return request({
            url: '/tz/handleSBYHModify',
            method: 'post',
            data: data
        })
    },
    handleSBYHSupervise: function (data) {
        return request({
            url: '/tz/handleSBYHSupervise',
            method: 'post',
            data: data
        })
    },
    // 现场监控
    getAccessTokenAndLocationList: function () {
        return request({
            url: '/tz/getAccessTokenAndLocationList1',
            method: 'get',
        })
    },
    // 主页
    getHomePageHJJCData: function (params) {
        return request({
            url: '/tz/getHomePageHJJCData',
            method: 'get',
            params: params
        })
    },
    getHomePageSDQData: function (params) {
        return request({
            url: '/tz/getHomePageSDQData',
            method: 'get',
            params: params
        })
    },
    getHomePageSWJGSMData: function (params) {
        return request({
            url: '/tz/getHomePageSWJGSMData',
            method: 'get',
            params: params
        })
    },
    getHomePageXCJKData: function () {
        return request({
            url: '/tz/getHomePageXCJKData',
            method: 'get'
        })
    },
    getHomePageZYData: function (params) {
        return request({
            url: '/tz/getHomePageZYData',
            method: 'get',
            params: params
        })
    },
    getHomePageZYSBData: function (params) {
        return request({
            url: '/tz/getHomePageZYSBData',
            method: 'get',
            params: params
        })
    },
    getHomePageSGHBData: function (params) {
        return request({
            url: '/tz/getHomePageSGHBData',
            method: 'get',
            params: params
        })
    },
    getHomePageSGZLData: function (params) {
        return request({
            url: '/tz/getHomePageSGZLData',
            method: 'get',
            params: params
        })
    },
    //获取监控链接
    getLiveUrl: function(){
        return request({
            url: '/tz/getLiveUrl',
            method: 'get',
        })
    }
}


// WEBPACK FOOTER //
// ./src/api/tz.js